import {
  LabelButton,
  Pagination,
  Table,
  TableColumns,
  useTableHelpers,
  useTablePagination,
} from '@teamsnap/snap-ui';
import { parseUtcToIsoDateTime } from 'core/utils';
import { DateFormat, DateService } from 'frontend-toolkit';
import {
  LoadingType,
  useOrderDetails,
  useOrderDetailsActions,
} from 'hooks/orderDetails';
import * as React from 'react';
import { useMemo, useState } from 'react';
import AddNoteSidebar from './add-note-sidebar';
import OrderDetailsTableSkeleton from './order-table-skeleton';

const columns: TableColumns = {
  body: {
    label: 'Note',
    align: 'left',
    width: '40%',
  },
  date: {
    label: 'Date',
    align: 'left',
    sort: 'date',
    getBodyProps: (row) => ({
      type: 'custom',
      children: row.date
        ? DateService.format(new Date(row.date), DateFormat.MM_DD_YYYY)
        : '',
    }),
    width: '120px',
  },
  createdByName: {
    label: 'Added By',
    align: 'left',
    width: '120px',
  },
};

const NotesList = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { notes, loading, order } = useOrderDetails();
  const { getNotes } = useOrderDetailsActions();

  React.useEffect(() => {
    getNotes(order?.id);
  }, []);

  const parsedData = useMemo(() => {
    if (!notes) {
      return [];
    }
    return notes.map((note) => ({
      // TODO parse data into the format expected by the NotesList component
      ...note,
      date: note.insertedAt ? parseUtcToIsoDateTime(note.insertedAt) : '',
    }));
  }, [notes]);

  const { rows, headerRow } = useTableHelpers({
    data: parsedData,
    columns: { ...columns },
    initialSorting: {
      method: 'date',
      sortKey: 'date',
      acsending: true,
    },
  });

  const { currentPage, onPageChange, totalCount, currentRows, pageSize } =
    useTablePagination({
      rows,
      pageSize: 10,
    });

  return (
    <div className="sui-flex sui-flex-col" data-testid="notes-table--sidebar">
      {loading[LoadingType.GetNotes] ? (
        <OrderDetailsTableSkeleton />
      ) : (
        <div className="sui-flex sui-flex-col">
          <LabelButton
            className="sui-flex sui-self-end sui-mb-2"
            onClick={() => setIsDrawerOpen(true)}
            data-testid="notes-table--add-note-button"
            variantType="secondary"
          >
            Add note
          </LabelButton>

          <Table
            data-testid="notes-table--table"
            headerRow={headerRow}
            rows={currentRows}
          />
          <Pagination
            className="sui-mt-3"
            {...{ currentPage, onPageChange, totalCount, pageSize }}
          />
          <AddNoteSidebar
            orderId={order?.id}
            show={isDrawerOpen}
            close={() => setIsDrawerOpen(false)}
            onSubmit={() => {
              setIsDrawerOpen(false);
              getNotes(+order?.id);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default NotesList;
